import { useEffect, useState } from 'react';
import { pendingShoppingChanges } from './shopping-store';
import { Button } from './ui';

export function UpdateNotice() {
  const [waiting, setWaiting] = useState<ServiceWorker | null>(null);
  const [pending, setPending] = useState(0);
  useEffect(() => {
    const sync = () => setPending(pendingShoppingChanges());
    window.addEventListener('shopping-save-state', sync);
    if ('serviceWorker' in navigator && import.meta.env.PROD) {
      void navigator.serviceWorker.register('/sw.js').then(registration => {
        setWaiting(registration.waiting);
        registration.addEventListener('updatefound', () => {
          const worker = registration.installing;
          worker?.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) setWaiting(registration.waiting);
          });
        });
      }).catch(() => { /* App remains usable without an offline shell. */ });
    }
    return () => window.removeEventListener('shopping-save-state', sync);
  }, []);
  if (!waiting && !pending) return null;
  return <aside role="status" className="mx-auto max-w-3xl border-b border-border-subtle bg-bg-raised px-5 py-3 text-sm">
    {pending > 0 ? `${pending} shopping change${pending === 1 ? '' : 's'} waiting to save. Keep the app open; return to Shopping to retry any failures.` : 'An app update is ready. Finish any open edits before reloading.'}
    {waiting && <Button variant="secondary" disabled={pending > 0} className="mt-2" onClick={() => {
      if (pendingShoppingChanges()) return;
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
      waiting.postMessage('SKIP_WAITING');
    }}>Update and reload</Button>}
  </aside>;
}
